import { useTranslations } from 'next-intl';
import { CatButton } from '@blocks-react/components/Button';
import { CatHeading } from '@blocks-react/components/Heading';
import { RequestServiceModal } from '@cat-ecom/pcc-components';
import { useMyEquipmentDrawer } from 'components/my-equipment/my-equipment-drawer-context';

const NoEquipmentModal = ({ modalClose, isRSModalOpen }) => {
  const t = useTranslations();
  const { addEquipmentDrawer } = useMyEquipmentDrawer();
  const handleAddEquipment = () => {
    modalClose();
    addEquipmentDrawer.openDrawer();
  };
  return (
    <RequestServiceModal
      isActive={isRSModalOpen}
      dismissible={false}
      disableBackdropClick={true}
      disableEscClick={true}
      size="sm"
    >
      <CatHeading slot="header" variant="title-sm" className="text-wrap">
        {t('NO_EQUIPMENT_PDP')}
      </CatHeading>
      <div className="py-2">
        <CatHeading variant="body-sm" className="u-color--Black text-wrap">
          {t('ADD_EQUIPMENT_TO_REQUEST_FOR_SERVICE_MESSAGE_PDP')}
        </CatHeading>
      </div>
      <div slot="footer" className="d-flex">
        <CatButton
          className="me-1 text-wrap"
          variant="primary"
          onClick={handleAddEquipment}
        >
          {t('MEQ_ADD_EQUIP')}
        </CatButton>
        <CatButton className="ms-1 text-wrap" onClick={modalClose}>
          {t('CANCEL')}
        </CatButton>
      </div>
    </RequestServiceModal>
  );
};

export default NoEquipmentModal;
